// Handles smooth scrolling to anchors on the size table page
// Scrolls targeted element into center of viewport

const findAnchor = (id) => {
  let el = document.getElementById(id);
  if (el) return el;

  const parts = id.split('-');
  for (let i = 1; i < parts.length; i += 1) {
    el = document.getElementById(parts.slice(i).join('-'));
    if (el) return el;
  }
  return null;
};

document.addEventListener('DOMContentLoaded', () => {
  const { hash } = window.location;
  if (hash) {
    const target = findAnchor(hash.substring(1));
    if (target) {
      // Reset to top before applying smooth scroll for consistent animation
      window.scrollTo(0, 0);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href').substring(1);
      const el = findAnchor(id);
      if (el) {
        event.preventDefault();
        history.replaceState(null, '', `#${id}`);
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
});

